import { UTCDate } from '@date-fns/utc';
import { isWithinInterval } from 'date-fns';
import { VendorView } from '../../../types/entity-types';

type HasVendorTransactionsInTimeframeArgs = {
  vendor: VendorView;
  startDate: Date;
  endDate: Date;
};

export const hasVendorTransactionsInTimeframe = ({
  vendor,
  startDate,
  endDate,
}: HasVendorTransactionsInTimeframeArgs) => {
  return vendor.transactions?.some((t) => isWithinInterval(new UTCDate(t.fspDate), { start: startDate, end: endDate }));
};
